import { render, staticRenderFns } from "./order-pay-alipay.vue?vue&type=template&id=1bff3f62&scoped=true&"
import script from "./order-pay-alipay.vue?vue&type=script&lang=js&"
export * from "./order-pay-alipay.vue?vue&type=script&lang=js&"
import style0 from "./order-pay-alipay.vue?vue&type=style&index=0&id=1bff3f62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bff3f62",
  null
  
)

export default component.exports